import React, { Component } from "react";
import { Table, Button, Modal, Switch, Col, Row, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ContratosForm from '../components/ContratosForm';
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalComissao: 0,
    totalContratos: 0,
    qtdeContratos: 0,
    formFiltroVisivel: false,
    idfContrato: 0,

    filtros: {
      tipoTela: 'CONTR',
      buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear() - 30, new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0' },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaMarcaProduto: { key: '0' },
      buscaServico: { key: '0' },
      buscaUsuario: { key: '0' },
      buscaSitFin: { key: 'X', },
      buscaSitContr: { key: '1', },
      buscaBloqueio: { key: 'X', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalContratos: 0, totalComissao: 0, qtdeContratos: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaSitContr, buscaBloqueio, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    // console.log('getListaRegistros: ', this.state.filtros)

    axios
      .get('/contratos', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          vendedor: buscaUsuario.key,
          sitContr: String(buscaSitContr.key),
          bloqueio: String(buscaBloqueio.key),
          faturar: 'X',
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;

        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
          totalContratos: response.data.totalcontratos,
          qtdeContratos: response.data.qtdecontratos,
          totalComissao: response.data.totalComissao,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.contr_idf) {
      request = axios.put(`/contratos/update/${registro.contr_idf}`, registro);
    } else {
      request = axios.post(`/contratos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Contrato gravado com sucesso');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }
      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          contr_idf: 0,
          contr_pessoa: { key: '0', label: '', },
          contr_numero: '',
          contr_data_emissao: moment().format('DD/MM/YYYY'),
          contr_data_cancelamento: '',
          contr_situacao: '',
          contr_bloqueio: '',
          contr_valor_inicial: 0,
          contr_valor_mensal: 0,
          contr_dia_venc: 0,
          contr_obs: '',
          contr_vendedor: { key: '0', label: '', },
          contr_controle: '',
          contr_tipo_pagto: { key: '0', label: '', },
          visualizando: false,
        }
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/contratos/show/${registro.contr_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.contr_pessoa = {
          key: String(data.dados.contr_pessoa),
          label: data.dados.pes_nome,
        }

        data.dados.contr_vendedor = {
          key: String(data.dados.contr_vendedor),
          label: '',
        }

        data.dados.contr_data_emissao = moment(data.dados.contr_data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.contr_tipo_pagto = {
          key: String(data.dados.contr_tipo_pagto),
          label: data.dados.td_descricao,
        }

        data.dados.visualizando = false;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/contratos/delete/${registro.contr_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.contr_idf === registro.contr_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: String(this.state.filtros.buscaUsuario),
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
        buscaSitContr: this.state.filtros.buscaSitContr,
        buscaBloqueio: this.state.filtros.buscaBloqueio,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/contratos/ativa/${registro.contr_idf}/1`)
    } else {
      request = axios.put(`/contratos/ativa/${registro.contr_idf}/0`)
    }

    request.then(response => {
      registro.contr_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderAtiva = (contr_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Vigente"
        unCheckedChildren="Cancelado"
        checked={contr_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('ContratosPage', 'editar') ? false : true}
      />
    );
  };

  onBloqueioChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/contratos/bloqueio/${registro.contr_idf}/1`)
    } else {
      request = axios.put(`/contratos/bloqueio/${registro.contr_idf}/0`)
    }

    request.then(response => {
      registro.contr_bloqueio = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderBloqueio = (contr_bloqueio, registro) => {
    return (
      <Switch
        checkedChildren="Sim"
        unCheckedChildren="Não"
        checked={contr_bloqueio ? true : false}
        onChange={ativar => this.onBloqueioChange(registro, ativar)}
        disabled={getTemPermissao('ContratosPage', 'editar') ? false : true}
      />
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderSitFinanc = (tit_situacao) => {
    return (
      <span> {tit_situacao === 'P' ? 'PAGO' : 'ABERTO'} </span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('ContratosPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('ContratosPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
        {/* <span>
          <Tooltip title="Impressão">
            <Button type="dashed" size="small" onClick={() => this.onImprimirClick(registro.contr_idf)} icon="printer" />
          </Tooltip>
        </span> */}
      </ButtonGroup>
    );
  };

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, total, pagina, limite } = this.state;

    // console.log('ContratosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Controle de Contratos</span>
        <div className="divider-page" />

        <div className="pageFiltro" style={{ height: 50, paddingTop: 10 }}>
          <Col xs={24} >
            <Col xs={8}>
              {getTemPermissao('ContratosPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />
            </Col>

            <Col xs={24} md={12} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde Contratos
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeContratos}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Contratos
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalContratos)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Comissão
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalComissao)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={6} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalContratos - this.state.totalComissao)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>
          </Col>

          <ContratosForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.contr_idf)}
          >
            <Column
              key="contr_numero"
              dataIndex="contr_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="contr_data_emissao"
              dataIndex="contr_data_emissao"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={120}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={350}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="contr_valor_mensal"
              dataIndex="contr_valor_mensal"
              title={this.renderTitulo("Valor Mensal")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="ue_perc_comissao"
              dataIndex="ue_perc_comissao"
              title={this.renderTitulo("% Comissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="vlr_comissao"
              dataIndex="vlr_comissao"
              title={this.renderTitulo("Valor Comissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="contr_situacao"
              dataIndex="contr_situacao"
              title={this.renderTitulo("Situação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderAtiva}
              width={60}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="contr_bloqueio"
              dataIndex="contr_bloqueio"
              title={this.renderTitulo("Bloqueado")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderBloqueio}
              width={60}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={90}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ContratosPage.js